import _ from "lodash";
import isEmpty from "lodash/isEmpty";
import { SIGN_IN } from "../constants/routes";
import { USERS_DASHBOARD } from "../constants/routes";
import { handleOnBeforeUnload } from "./common-utils";
import {logoutSuccess} from "../store/actions";
import store from "../store";

// Function help to check has error of input
const hasErrorInput = (errors, inputName) => {
  if (_.has(errors, inputName)) {
    return true;
  }
  return false;
};

// Function help get the error message of input
const getInputErrorMessage = (errors, inputName) => {
  if (_.has(errors, inputName)) {
    return errors[inputName];
  }
  return "";
};

// Function help to get error in alert error message
const getAlertErrorMessage = (errors, errorName = undefined) => {
  if (isEmpty(errorName)) {
    errorName = "error_message";
  }
  if (_.has(errors, errorName)) {
    return errors[errorName];
  }
  return "";
};

const getFormErrorResponseData = (error) => {
  if (isEmpty(error.response)) {
    return null;
  }
  if (isEmpty(error.response.data)) {
    return null;
  }
  return error.response.data;
};

// Function help to get error list in alert
const getErrorList = (errorData) => {
  if (_.has(errorData, "errors")) {
    if (
      errorData.errors &&
      typeof errorData.errors === "object" &&
      Object.keys(errorData.errors).length > 0
    ) {
      const errorListContent = Object.keys(errorData.errors).map((key) => {
        const errorValue = errorData.errors[key];
        if (typeof errorValue === "object" && errorValue != null) {
          const errorDetails = Object.keys(errorValue)
            .map((detailKey) => `${detailKey}: ${errorValue[detailKey]}`)
            .join(", ");
          return `${errorDetails}`;
        } else {
          return `${errorValue}`;
        }
      });
      return errorListContent;
    }
  }

  return [];
};

// Function help to get list error message unique
const getUniqueErrorMessages = (errors) => {
  const messages = new Set();
  Object.values(errors).forEach((errorObj) => {
    Object.values(errorObj).forEach((message) => {
      messages.add(message);
    });
  });

  return [...messages];
};

const getUniqueErrorMessagesArray = (errors) => {
  const messages = new Set();
  Object.values(errors).forEach((message) => {
    messages.add(message);
  });

  return [...messages];
};

// Function help to get error list in alert
const getError = (error) => {
  if (_.has(error, "errors")) {
    return error.errors;
  }
  return null;
};

// Function check input error batch
const hasErrorBatch = (id, columnName, errors) => {
  if (typeof errors !== "object" || errors === null) {
    return false;
  }

  return errors[id] && errors[id][columnName];
};

// show error messages on a list
const showErrorMessages = (errorMsg) => {
  if (_.isEmpty(errorMsg)) {
    return null;
  }

  let listMesg = Object.keys(errorMsg).map((key) => {
    return <li key={key}>{errorMsg[key]}</li>;
  });
  return (
    <div className="error-block">
      <ul>{listMesg}</ul>
    </div>
  );
};

// return error css class if has error
const hasError = (errorItems, itemName) => {
  if (!_.isEmpty(errorItems) && errorItems.includes(itemName)) {
    return "error-input";
  }
  return "";
};

// check item is invalid
const invalid = (errorItems, itemName) => {
  return !_.isEmpty(errorItems) && errorItems.includes(itemName);
};

// handle errors response status
const errorStatusHandle = (response) => {
  let status = response?.status ?? 0;
  if (status === 401) {
      store.dispatch(logoutSuccess());
      window.location.href = SIGN_IN;
  }
  if (status === 500 || status === 404 || status === 403) {
    const regexApiUser = /api\/\w+\/users/;
    if (regexApiUser.test(response.config.url)) {
      localStorage.setItem("backUrl", USERS_DASHBOARD);
    }
    if (status === 500) {
      window.removeEventListener("beforeunload", handleOnBeforeUnload);
      localStorage.setItem("errorDetail", response.data.error_message);
    }
    window.location.href = "/error-" + status;
  }
};

export {
  hasErrorInput,
  getInputErrorMessage,
  getAlertErrorMessage,
  getFormErrorResponseData,
  getErrorList,
  getError,
  getUniqueErrorMessages,
  hasErrorBatch,
  getUniqueErrorMessagesArray,
  showErrorMessages,
  hasError,
  invalid,
  errorStatusHandle,
};
